import React from "react";
import { CardActions } from "material-ui/Card";
// import FlatButton from "material-ui/FlatButton";
import {
  Create,
  Edit,
  LongTextInput,
  ListButton,
  RefreshButton,
  showNotification
} from "admin-on-rest";
import OrderForm from "./OrderForm";
import EditOrderForm from "./EditOrderForm";
// import { RestApi } from "../restClient";
import { push } from "react-router-redux";
import { connect } from "react-redux";
const newDate = new Date();

const customer_info = {
  email: "",
  first_name: "",
  last_name: "",
  phone: "",
  site_id: 1,
  address: "",
  country: "",
  province: "",
  city: "",
  zip: ""
};
const amounts = {
  subtotal: 0,
  total: 0,
  coupon: 0,
  custom: 0,
  total_items: 0,
  shipping: 0
};

export const postDefaultValue = {
  issued_at: newDate,
  amounts: amounts,
  customer_info: customer_info
};

const FullNameField = ({ record = {} }) => {
  return (
    <span>
      {record.first_name} {record.last_name}
    </span>
  );
};
FullNameField.defaultProps = { label: "Fullname" };

export const OrderCreate = props => (
  <Create {...props}>
    <OrderForm {...props} defaultValue={postDefaultValue}>
      <LongTextInput
        label="resources.orders.fieldList.tracking"
        source="tracking"
      />
    </OrderForm>
  </Create>
);

const OrderRef = ({ record }) => {
  return <span>Order #{record ? `${record.ref}` : ""}</span>;
};

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right"
};

const OrderEditActions = connect(
  null,
  { showNotification, push }
)(({ basePath, data, showNotification, push }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
    <RefreshButton />
    {/* { data && data.status==="pending payment" && <FlatButton primary label="Paid Manually" onClick={function(){
      RestApi("/orders/"+data.id+"/pay").then(response =>
        response.text().then(text => ({
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
            body: text,
        }))).then(function(response){
        if(response.status>=200 && response.status<300){
          showNotification('Order paid successfully');
          push('/orders');
        } else {
          showNotification(JSON.parse(response.body).message, 'warning');
        }
      });
    }} />} */}
  </CardActions>
));
export const OrderEdit = props => (
  <Edit {...props} title={<OrderRef />} actions={<OrderEditActions />}>
    {permissions => (
      <EditOrderForm
        {...props}
        defaultValue={postDefaultValue}
        permissions={permissions}
      >
        <LongTextInput
          label="resources.orders.fieldList.tracking"
          source="tracking"
        />
      </EditOrderForm>
    )}
  </Edit>
);



// WEBPACK FOOTER //
// ./src/orders/Create.js